import type { ContentType } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export enum FlagReasonType {
  Inappropriate = 1,
  Offensive = 2,
  Spam = 3,
  Violence = 4,
  Harassment = 5,
  Other = 6,
}

export interface IContentFlagRequest {
  contentId: number
  contentType: ContentType
  reason?: FlagReasonType
  reasonDetails?: string
}

export async function flagInappropriateContent(eventVaultId: number, contentFlagRequest?: IContentFlagRequest) {
  const response = await v1.post(`/${eventVaultId}/moderate/flag`, contentFlagRequest)

  return response.data.message
}

interface UseFlagInappropriateContentArgs {
  eventVaultId: number
  content: IContentFlagRequest
}

const FLAG_INAPPROPRIATE_CONTENT_KEY = "flagInappropriateContent"

export function useFlagInappropriateContent() {
  return useMutation({
    mutationKey: [FLAG_INAPPROPRIATE_CONTENT_KEY],
    mutationFn: ({ eventVaultId, content }: UseFlagInappropriateContentArgs) =>
      flagInappropriateContent(eventVaultId, content),
  })
}
